import {  Injectable } from '@angular/core';
import { GroupFboViewModel } from '../models/groups';

@Injectable()
export class ManageFboGroupsService {
    public getGroupFbos(groupsFbosData: GroupFboViewModel,groupId: number) {
        return groupsFbosData.fbos.filter(
            (fbo) => fbo.groupId === groupId
        );
    }
    public isSingleSourceFbo(groupsFbosData: GroupFboViewModel,icao: string): boolean {
        return groupsFbosData.fbos.filter(f => f.icao == icao).length == 1;
    }
    public getIsNetworkFboSearchByGroup(groupsFbosData: GroupFboViewModel,groupId: number): boolean{
        var groupFbos =  groupsFbosData.groups.find(g => g.oid == groupId);
        return groupFbos?.fboCount > 1;
    }
    public getIsNetworkFboSearchByFboList(groupFboList: any[]): boolean {
        return groupFboList.length > 1;
    }
}
